import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminRoute() {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${BACKEND_URL}/api/admin/me`, { withCredentials: true })
      .then(() => {
        if (!cancelled) setStatus('ok');
      })
      .catch(() => {
        if (cancelled) return;
        // Session is dead — purge stale marker so AdminLogin doesn't
        // ping-pong us back to /admin/dashboard on the redirect below.
        try { localStorage.removeItem('admin_user'); } catch (_) { /* ignore */ }
        setStatus('denied');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-red-600" />
      </div>
    );
  }

  if (status === 'denied') {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
}
